<template>
  <el-card class="iot-dtu iot-search-header public-page-style">
    <div slot="header">
      <el-form :inline="true" :model="getForm">
     
        <el-form-item>
          <el-input
            size="mini"
            clearable
            @change="getDtuPage"
            v-model="getForm.dtuSn"
            style="width:180px"
            placeholder="请输入查询的序列号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="firmwareTypeId" >
          <el-select
          size="mini"
            v-model="getForm.bindingState"
            filterable
            clearable
            @change="getDtuPage"
             style="width:180px"
            placeholder="请选择绑定状态类型"
          >
            <el-option
              label="绑定"
              value="1"
            ></el-option>
            <el-option
              label="解绑"
              value="2"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" plain @click="getDtuPage()"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div style="height:70%">
      <el-table
      :data="tableData"
      stripe
      border=""
      class="dtu-tab"
      :header-cell-style="{ background: theme.TABLE_HEADER_COLOR }"
      max-height="650"
    >
    <el-table-column
        prop="dtuSn"
        label="序列号"
        
        sortable
      ></el-table-column>
      <el-table-column
    
        label="绑定状态"
       
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.bindingState == 1">绑定</el-tag>
          <el-tag type="info" v-else-if="scope.row.bindingState == 2">解绑</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="ip"
        label="IP地址"
       
        sortable
      ></el-table-column>
      
      <el-table-column
        prop="addr"
        label="真实地址"
        
      ></el-table-column>
      <el-table-column
        prop="clientType"
        label="终端"
      >
       <template slot-scope="scope">
          <el-tag  v-if="scope.row.clientType == 1">安卓</el-tag>
          <el-tag  v-else-if="scope.row.clientType == 2">苹果</el-tag>
          <el-tag  v-else-if="scope.row.clientType == 3">电脑</el-tag>
          <el-tag  v-else-if="scope.row.clientType ==4">其他</el-tag>
        </template>
      </el-table-column>
       <el-table-column
        prop="operationTime"
        label="操作日期"
        
      ></el-table-column>
      
    </el-table>
    </div>
    
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="getForm.current"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="getForm.size"
      :total="getForm.total"
      layout="total, sizes, prev, pager, next, jumper"
      style="text-align: right; margin-top: 10px; margin-right: 10px"
    ></el-pagination>
  </el-card>
</template>
<script>
import { TABLE_HEADER_COLOR } from "../util/theme";

let that;
export default {
  name: "CreateDtu",
  data() {
    return {
      theme: { TABLE_HEADER_COLOR },
      tableData: [],
      getForm: {
        size: 10,
        current: 1,
        total: 0,
        dtuSn: "",
        bindingState: "",
      },
    };
  },
  methods: {
    handleSizeChange(val) {
      that.$set(that.getForm, "size", val);
      that.$set(that.getForm, "current", 1);
      that.getDtuPage(that.getForm);
    },
    handleCurrentChange(val) {
      that.$set(that.getForm, "current", val);
      that.getDtuPage(that.getForm);
    },

    getDtuPage() {
      that.$api.dtu.dtuBindingLogPage(that.getForm).then((response) => {
        if (response.code == 200) {
          that.tableData = response.data.records;
          that.getForm.total = response.data.total;
        }
      });
    },
  },
  beforeCreate() {
    that = this;
  },
  mounted() {
    that.getDtuPage();
    // that.hardwareList();
    // that.networkModeList();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-select,
.el-input,
.el-input-number {
  width: 250px;
}
.el-input-number >>> input {
  text-align: left;
}
.iot-dtu-create {
  float: right;
  margin-top: 8px;
}
.iot-dtu-permission {
  height: 387px;
}
.iot-search-header >>> .el-card__header {
  padding: 0 18px;
}
.iot-dtu >>> .iot-step-body {
  width: 100%;
  height: calc(100% - 40px);
  padding: 30px;
}

.iot-dtu >>> .el-dialog__body {
  width: 95%;
  height: 90%;
  overflow: hidden;
}

.dtu-tab {
  overflow-x: auto;
}
.iot-dtu >>> .el-form-item {
  vertical-align: middle;
}
</style>
